module.exports = __webpack_public_path__ + "static/img/products application_Semi-rigid PVC4.eea553d5.jpg";